import { forwardRef } from 'react';

type TextareaProps = React.ComponentProps<'textarea'> & {
  label: string;
  errorMessage?: string;
  hasError?: boolean;
};

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, id, rows, errorMessage, hasError, ...rest }, ref) => {
    return (
      <div id="name_wrapper" data-testid="name_wrapper" className="flex w-full flex-col gap-2">
        <label className="text-sm font-regular uppercase text-grey-900" htmlFor={id}>
          {label}
        </label>
        <span className="group flex w-full cursor-text items-center gap-4 rounded bg-grey-200 stroke-grey-700 px-4 py-2 text-grey-700 ring-1 ring-grey-200 focus-within:ring-grey-700 hover:ring-grey-400 hover:focus-within:ring-grey-700">
          <span className="flex w-full gap-1">
            <textarea
              ref={ref}
              id={id}
              className="m-0 flex w-full cursor-text border-none bg-transparent p-0 text-left text-grey-900 outline-none ring-0 ring-transparent placeholder:text-grey-500 focus:outline-none focus:ring-0 focus:ring-transparent"
              rows={rows}
              {...rest}
            />
          </span>
        </span>
        {hasError && errorMessage && (
          <p id={`${id}_error_message`} className="text-xs font-regular text-red">
            {errorMessage}
          </p>
        )}
      </div>
    );
  }
);
